import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next'; // 1. Import useTranslation
import { FaHeartbeat, FaProcedures, FaThermometerHalf, FaChevronRight, FaAward, FaHandshake, FaHistory, FaBullseye } from 'react-icons/fa';
import "./about.css";
import "./Navbar.js";

export default function About() {
  const { t } = useTranslation(); // 2. เรียกใช้ Hook แปลภาษา

  const values = [
    {
      icon: <FaAward />,
      title: t('value1Title', 'คุณภาพสูงสุด'),
      description: t('value1Desc', 'สินค้าทุกชิ้นผ่านการรับรองมาตรฐานสากล มั่นใจได้ในประสิทธิภาพ')
    },
    {
      icon: <FaHandshake />,
      title: t('value2Title', 'บริการเป็นเลิศ'),
      description: t('value2Desc', 'ทีมงานมืออาชีพพร้อมให้คำปรึกษาและดูแลหลังการขายอย่างใกล้ชิด')
    },
    {
      icon: <FaHistory />,
      title: t('value3Title', 'ประสบการณ์ยาวนาน'),
      description: t('value3Desc', 'ความเชี่ยวชาญในธุรกิจอุปกรณ์การแพทย์ที่สั่งสมมาอย่างยาวนาน')
    },
    {
      icon: <FaBullseye />,
      title: t('value4Title', 'เป้าหมายชัดเจน'),
      description: t('value4Desc', 'มุ่งมั่นสู่การเป็นผู้นำด้านเครื่องมือแพทย์ในภูมิภาคอีสานใต้')
    }
  ];

  const devices = [
    {
      icon: <FaHeartbeat style={{ color: '#216488' }} />, // 🔵 ปรับสีตรงนี้
      title: t('device1Title', 'เครื่องตรวจวัดชีพจร'),
      description: t('device1Desc', 'เครื่องวัดความดันโลหิต, เครื่องวัดออกซิเจนปลายนิ้ว, ECG Monitor ความแม่นยำสูง'),
      className: 'icon-primary' 
    },
    {
      icon: <FaProcedures style={{ color: '#216488' }} />, // 🔵 ปรับสีตรงนี้
      title: t('device2Title', 'เตียงผู้ป่วย & ห้องพักฟื้น'),
      description: t('device2Desc', 'เตียงไฟฟ้า, เตียงปรับระดับ, รถเข็น และอุปกรณ์ช่วยเหลือผู้ป่วยครบวงจร'),
      className: 'icon-secondary'
    },
    {
      icon: <FaThermometerHalf style={{ color: '#216488' }} />, // 🔵 ปรับสีตรงนี้
      title: t('device3Title', 'อุปกรณ์พื้นฐาน & เวชภัณฑ์'),
      description: t('device3Desc', 'เครื่องวัดไข้ดิจิทัล, ปรอทวัดไข้, อุปกรณ์ปฐมพยาบาล สำหรับใช้ในบ้านและโรงพยาบาล'),
      className: 'icon-accent'
    }
  ];

  return (
    <section className="about-page">
      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>{t('aboutPageTitle', 'เกี่ยวกับเรา')}</h1>
          <p className="about-tagline">{t('aboutTagline', 'ผู้นำด้านอุปกรณ์การแพทย์ มาตรฐานสากล')}</p>
          <div className="hero-divider"></div>
        </div>
      </div>

      {/* Introduction */}
      <div className="about-container">
        <div className="about-intro">
          <div className="intro-text">
            <h2>{t('companyFullName', 'บริษัท แอสเซนท์ คอร์ปอเรชั่น จำกัด')}</h2>
            <p>
              {t('companyIntroDesc', 'เราคือผู้นำเข้าและจัดจำหน่ายอุปกรณ์การแพทย์ที่ทันสมัยและได้มาตรฐานสากล คัดสรรสินค้าคุณภาพสูงจากทั่วโลก เพื่อตอบโจทย์โรงพยาบาล คลินิก และผู้ใช้งานทั่วไป ด้วยความมุ่งมั่นที่จะยกระดับคุณภาพชีวิตของผู้ป่วยผ่านเทคโนโลยีทางการแพทย์ที่ดีที่สุด')}
            </p>
          </div>
        </div>

        {/* Vision & Mission */}
        <div className="vision-mission-grid">
          <div className="vm-card vision">
            <div className="vm-icon"><FaBullseye /></div>
            <h3>{t('visionSectionTitle', 'วิสัยทัศน์ (Vision)')}</h3>
            <p>{t('visionSectionDesc', 'มุ่งเน้นเป็นผู้นำเข้าและจำหน่ายเครื่องมือแพทย์ที่ใหญ่ที่สุดในอีสานใต้ พัฒนาสินค้าให้มีคุณภาพตอบโจทย์ลูกค้า สร้างความเชื่อมั่นด้วยนวัตกรรมที่ทันสมัย')}</p>
          </div>
          <div className="vm-card mission">
            <div className="vm-icon"><FaHandshake /></div>
            <h3>{t('missionSectionTitle', 'พันธกิจ (Mission)')}</h3>
            <p>{t('missionSectionDesc', 'ให้บริการด้วยทีมงานเชี่ยวชาญ สนับสนุนสถานพยาบาลในการดูแลผู้ป่วยด้วยอุปกรณ์ที่ได้มาตรฐาน และบริการหลังการขายที่รวดเร็ว')}</p>
          </div>
        </div>

        {/* Values Section */}
        <div className="section-block">
          <h2 className="section-header">{t('coreValuesTitle', 'ค่านิยมองค์กร')}</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon-wrapper">{value.icon}</div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Devices Section */}
        <div className="section-block bg-light">
          <h2 className="section-header">{t('productsAndServicesTitle', 'สินค้าและการบริการ')}</h2>
          <div className="devices-grid">
            {devices.map((device, index) => (
              <div key={index} className="device-card">
                <div className={`device-icon ${device.className}`}>
                  {device.icon}
                </div>
                <h3>{device.title}</h3>
                <p>{device.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="about-cta-wrapper">
        <div className="about-cta">
          <h2>{t('aboutCtaTitle', 'พร้อมดูแลคุณด้วยอุปกรณ์คุณภาพ')}</h2>
          <p>{t('aboutCtaDesc', 'ปรึกษาทีมงานผู้เชี่ยวชาญของเราได้ทันที')}</p>
          <div className="cta-buttons">
            <Link to="/contact" className="cta-btn btn-primary">
              {t('contactUsBtn', 'ติดต่อเรา')} <FaChevronRight />
            </Link>
            <Link to="/products" className="cta-btn btn-outline">
              {t('viewAllProductsBtn', 'ดูสินค้าทั้งหมด')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}